import React from 'react';
import { OrderStatus, OrderStatusContainer } from './styles.js';

import recebido from '../../assets/recebido.svg';
import separacao from '../../assets/separacao.svg';
import transito from '../../assets/transito.svg';
import entregue from '../../assets/entregue.svg';
import ceta from '../../assets/ceta.svg';

import recebido_marker from '../../assets/recebido_marker.svg';
import separacao_marker from '../../assets/separacao_marker.svg';
import transito_marker from '../../assets/transito_marker.svg';
import entregue_marker from '../../assets/entregue_marker.svg';
import ceta_marker from '../../assets/ceta_marker.svg';

function OrderProcess({ status }) {
  return (
    <OrderStatusContainer>
      <div>
        <p
          style={{
            color:
              (status === 'AAA' ||
                status === 'CBA' ||
                status === 'CBB' ||
                status === 'CCC' ||
                status === 'APP') &&
              '#00B050',
          }}
        >
          {status === 'AAA' ||
          status === 'CBA' ||
          status === 'CBB' ||
          status === 'CCC' ||
          status === 'APP'
            ? 'Concluído'
            : 'Não Iniciado'}
        </p>
        <OrderStatus>
          {status === 'AAA' ||
          status === 'CBA' ||
          status === 'CBB' ||
          status === 'CCC' ||
          status === 'APP' ? (
            <img src={recebido_marker} alt="" />
          ) : (
            <img src={recebido} alt="" />
          )}
        </OrderStatus>
        <p>Pedido recebido</p>
      </div>
      {status === 'AAA' ||
      status === 'CBA' ||
      status === 'CBB' ||
      status === 'CCC' ||
      status === 'APP' ? (
        <img src={ceta_marker} width={30} height={30} alt="" />
      ) : (
        <img src={ceta} width={30} height={30} alt="" />
      )}

      <div>
        <p
          style={{
            color:
              (status === 'CBA' ||
                status === 'CBB' ||
                status === 'CCC' ||
                status === 'APP') &&
              '#00B050',
          }}
        >
          {status === 'CBA' ||
          status === 'CBB' ||
          status === 'CCC' ||
          status === 'APP'
            ? 'Concluído'
            : 'Não Iniciado'}
        </p>
        <OrderStatus>
          {status === 'CBA' ||
          status === 'CBB' ||
          status === 'CCC' ||
          status === 'APP' ? (
            <img src={separacao_marker} alt="" />
          ) : (
            <img src={separacao} alt="" />
          )}
        </OrderStatus>
        <p>Pedido em separação</p>
      </div>

      {status === 'CBA' ||
      status === 'CBB' ||
      status === 'CCC' ||
      status === 'APP' ? (
        <img src={ceta_marker} width={30} height={30} alt="" />
      ) : (
        <img src={ceta} width={30} height={30} alt="" />
      )}

      <div>
        <p
          style={{ color: (status === 'CCC' || status === 'APP') && '#00B050' }}
        >
          {status === 'CCC' || status === 'APP' ? 'Concluído' : 'Não Iniciado'}
        </p>
        <OrderStatus>
          {status === 'CCC' || status === 'APP' ? (
            <img src={transito_marker} alt="" />
          ) : (
            <img src={transito} alt="" />
          )}
        </OrderStatus>
        <p>Pedido em transito</p>
      </div>

      {status === 'CCC' || status === 'APP' ? (
        <img src={ceta_marker} width={30} height={30} alt="" />
      ) : (
        <img src={ceta} width={30} height={30} alt="" />
      )}

      <div>
        <p style={{ color: status === 'APP' && '#00B050' }}>
          {status === 'APP' ? 'Concluído' : 'Não Iniciado'}
        </p>
        <OrderStatus>
          {status === 'APP' ? (
            <img src={entregue_marker} alt="" />
          ) : (
            <img src={entregue} alt="" />
          )}
        </OrderStatus>
        <p>Pedido entregue</p>
      </div>
    </OrderStatusContainer>
  );
}

export default OrderProcess;
